(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyBar = document.querySelector('.sense-mobile-sticky-atc');
    const stickyButton = document.querySelector('.sense-mobile-sticky-atc__button');
    const productForm = document.querySelector('product-form form[action*="/cart/add"]');
    const originalButton = productForm ? productForm.querySelector('.product-form__submit, button[name="add"]') : null;

    const proofTemplate = document.querySelector('[data-sense-amazon-proof-template]');
    const productInfo = document.querySelector('.product__info-container');

    if (proofTemplate && productInfo && !productInfo.querySelector('.sense-amazon-proof')) {
      const proof = proofTemplate.content.firstElementChild.cloneNode(true);
      const rating = productInfo.querySelector('.rating-wrapper');
      const title = productInfo.querySelector('.product__title');

      if (rating) {
        rating.insertAdjacentElement('afterend', proof);
      } else if (title) {
        title.insertAdjacentElement('afterend', proof);
      } else {
        productInfo.prepend(proof);
      }
    }

    if (!stickyBar || !stickyButton || !originalButton) {
      if (stickyBar) stickyBar.hidden = true;
      return;
    }

    document.body.classList.add('sense-sticky-atc-enabled');

    function updateState() {
      stickyButton.disabled = originalButton.disabled;
      const originalTextElement = originalButton.querySelector('span');
      const originalText = originalTextElement ? originalTextElement.textContent.trim() : originalButton.textContent.trim();
      if (originalText) stickyButton.textContent = originalText;
    }

    stickyButton.addEventListener('click', function () {
      if (!originalButton.disabled) originalButton.click();
    });

    document.addEventListener('change', function () { window.setTimeout(updateState, 100); });

    new MutationObserver(updateState).observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'class']
    });

    updateState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-product-details-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){document.querySelectorAll('[data-sense-food-root]').forEach(function(root){const details=root.querySelector('[data-sense-food-details]');const blocks=root.querySelectorAll('.sense-variant-food-info');if(!details||!blocks.length)return;function update(){const input=document.querySelector('form[action*="/cart/add"] [name="id"]');const fromUrl=new URLSearchParams(window.location.search).get('variant');const id=input&&input.value?input.value:fromUrl;let found=false;blocks.forEach(function(block,index){const show=id?String(block.dataset.variantId)===String(id):index===0;block.hidden=!show;if(show)found=true});details.hidden=!found}function delayed(){update();setTimeout(update,80);setTimeout(update,220)}document.addEventListener('change',delayed);document.addEventListener('variant:change',delayed);document.addEventListener('theme:variant:change',delayed);update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init()})();

  } catch(e) { console.error(e); }
})();
})();
